import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import AdminRequestService from "services/admin-request";

import BlockAction from "./pages/BlockAction";
import BlockSistem from "./pages/BlockSistem";
import RedemptionRequestPeriod from "./pages/RedemptionRequestPeriod";
import LoadPage from "components/LoadPage";

export default function Admin(){
  const [menu, setMenu] = useState([])
  const [select_index, set_select_index] = useState(0);
  const [page_load, set_page_load] = useState(true)

  const ref = useRef();

  useEffect(()=>{
    // let bar1 = document.getElementById("menu-top-1");
    // let bar2 = document.getElementById("menu-top-2");

    // if(bar1 && bar2){
    //   bar1.style.display = "none";
    //   bar2.style.display = "none";
    // }

    // return ()=>{
    //   if(bar1 && bar2){
    //     bar1.style.display = "";
    //     bar2.style.display = "";
    //   }
    // }
  },[])

  useEffect(()=>{
    function move(menu_item, x){
      menu_item.querySelector("span").style.marginLeft = `-${x}px`;
    }
    document.querySelectorAll(".menu-item").forEach(menu_item=>{
      const span = menu_item.querySelector("span");
      let animation;
      let dif = span.getBoundingClientRect().width - menu_item.getBoundingClientRect().width + 20;
      if(dif > 0){
        span.style.width = `${span.getBoundingClientRect().width}px`;
        span.style.overflowX = "hidden";
        menu_item.onmouseenter = ()=>{
          let x = 0;
          let time = 2000/(dif+10);
          animation = setInterval(() => {
            if(x <= dif){
              move(menu_item,x)
            }
            x++;
            if(x > dif+10){
              x = 0;
            }
          }, time);
        }
        menu_item.onmouseleave = ()=>{
          clearInterval(animation);
          move(menu_item,0)
        }
      }
    })
  },[menu])

  useEffect(() => {
    AdminRequestService.getCompaniesList().then(({ data }) => {
      set_page_load(false);
      setMenu([
        {label:"Período de solicitação de resgate",page:<RedemptionRequestPeriod companiesList={data}/>},
        {label:"Bloqueio de canais ao sistema",page:<BlockSistem companiesList={data}/>},
        {label:"Bloqueio de canais para reembolso",page:<BlockAction companiesList={data}/>},
      ]);
    })
  }, []);

  if(page_load){
    return <LoadPage/>
  }

  return (
    <div className={"page-menu-area"}>
      <div className="page-menu-title">Configurações do sistema</div>
      <div className="page-menu-down">
        <div className="menu-area">
          {menu.map((item, key)=>{
            return <div className={"menu-item"+(select_index===key?" selected":"")} key={key} onClick={()=>{
              set_select_index(key)
            }}><span>{item.label}</span></div>
          })}
        </div>
        <div className="menu-content-page" ref={ref}>
          {menu.length > select_index?menu[select_index].page:""}
        </div>
      </div>
    </div>
  );
}